"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDriverStatusToString = transformDriverStatusToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformDriverStatusToString(driverStatus) {
    switch (driverStatus) {
        case legacy_enums_1.DriverStatus.Active:
            return "active";
        case legacy_enums_1.DriverStatus.Declined:
            return "declined";
        case legacy_enums_1.DriverStatus.Hired:
            return "hired";
        default:
            return "unknown";
    }
}
//# sourceMappingURL=transformDriverStatusToString.js.map